import React, { useState, useEffect } from "react";
import serviceProvider from '../../services/axios'
import { NotificationView } from "./notification-view";
export const NotificationController = (props) => {
	const [results, setResults] = useState([]);
	const [refresh, setRefresh] = useState("");
	const user = JSON.parse(localStorage.getItem("userData"));
	const usid = user ? user.uid : 0;
	useEffect(() => {
		const search = async () => {
			const apiUrl = `/notification?type=all&uid=${usid}`;
			const { data } = await serviceProvider.get(apiUrl,true,{});
			setResults(data);
		};
		search();
	}, [refresh]);

	return <NotificationView notificationData={results} onRefresh={setRefresh} {...props} />;
};
